import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function IntegrationMsTeamsRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.IntegrationMsTeams', {
		url: '/admin/integrations/msteams',
		controllerAs: 'vm',
		controller: IntegrationMsTeamsCtrl,
		templateUrl: '/ng/hub/Integration/MsTeams/IntegrationMsTeamsCtrl.html?' + window.BUILD,
		permission: ['manage_msteams'],
		resolve: {
			style: () => AssetManager.css('/ng/hub/Integration/MsTeams/IntegrationMsTeamsCtrl.css'),
			$title: () => 'Microsoft Teams Integration',
		},
	});
}

export class IntegrationMsTeamsCtrl {
	constructor(Api, Identity) {
		'ngInject';
		const allHubs = Identity.hubsInThisAccount();

		this.isLoading = true;
		this.isSaving = false;
		this.isAffiliation = false;
		this.Api = Api;
		this.enabledErr = '';
		this.imgVer = '20201103';
		this.hubCheckboxes = [...allHubs];
		this.affiliationId = Identity.currentAffiliationId();

		this.initEnabled();
	}

	/**
	 * Initializes enabled checkboxes
	 */
	async initEnabled() {
		const data = await this.getEnabledData();
		this.updateEnabled(data);
		this.isLoading = false;
	}

	/**
	 * Pulls enable-checkbox data from the api
	 */
	async getEnabledData() {
		const url = `/v3/msteams/integration/account/${this.affiliationId}`;
		const resp = await this.Api.request('get', url);
		let ret = [];
		if (this.hasBadResponse(resp)) {
			this.enabledErr = 'Unable to pull integration info';
		} else {
			ret = resp.data;
		}
		return ret;
	}

	/**
	 * Checks for bad http-response status
	 * @param {Object} resp - The http-response object
	 * @returns {Boolean}
	 */
	hasBadResponse(resp) {
		return !resp.status || typeof resp.data == 'undefined' || resp.status < 200 || resp.status > 299;
	}

	/**
	 * Updates enabled checkboxes
	 */
	updateEnabled(data) {
		this.hubCheckboxes = [...this.hubCheckboxes].map(hub => {
			return { ...hub, checked: false };
		});
		this.isAffiliation = data.affiliation || false;
		this.hubCheckboxes = [...this.hubCheckboxes].map(hub => {
			const chk = data.hub_ids.includes(hub.id.toString());
			return { ...hub, checked: chk };
		});
	}

	/**
	 * Enable-checkbox change handler
	 */
	async toggleEnabled(info) {
		this.isSaving = true;

		if (info === 'affiliation') {
			this.isAffiliation = !this.isAffiliation;
			await this.saveAffiliation();
		} else {
			info.checked = !info.checked;
			await this.saveEnabledHubs();
		}

		this.isSaving = false;
		return true;
	}

	/**
	 * Saves enabled data for affiliation
	 */
	async saveAffiliation() {
		const enabledHubs = this.getEnabledHubs();
		const data = {
			is_affiliation: this.isAffiliation,
			hub_ids: enabledHubs,
		};
		await this.saveEnabled(data);
	}

	/**
	 * Returns currently-selected hubs
	 */
	getEnabledHubs() {
		return this.hubCheckboxes.filter(h => h.checked).map(h => h.id);
	}

	/**
	 * Makes enable-data save call to api
	 */
	async saveEnabled(data) {
		const url = `/v3/msteams/integration/account/${this.affiliationId}`;
		const resp = await this.Api.request('patch', url, data);
		if (this.hasBadResponse(resp)) {
			this.enabledErr = 'Unexpected error saving data';
		}
	}

	/**
	 * Saves enabled data for hubs
	 */
	async saveEnabledHubs() {
		const enabled = this.getEnabledHubs();
		const data = { hub_ids: enabled };
		await this.saveEnabled(data);
	}
}
